module.exports = __webpack_public_path__ + "static/media/Avenir-Black.b1abb878.otf";